import { render, staticRenderFns } from "./Slots.vue?vue&type=template&id=29f6f428&scoped=true"
import script from "./Slots.vue?vue&type=script&lang=js"
export * from "./Slots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f6f428",
  null
  
)

export default component.exports